import { call, put, takeEvery } from "redux-saga/effects"

import { GET_SERVICES, ADD_NEW_SERVICE, UPDATE_SERVICE, DELETE_SERVICE } from "./actionTypes";
import {
    getServicesSuccess,
    getServicesFail,
    addServiceSuccess,
    addServiceFail,
    updateServiceSuccess,
    updateServiceFail,
    deleteServiceSuccess,
    deleteServiceFail,
   
} from "./actions"

import {
    getServices,
    addNewService,
    updateService,
    deleteService,
   
} from "helpers/services/services_backend_helper";
import { toast } from "react-toastify";

function* fetchServices() {
    try {
        const response = yield call(getServices)
        yield put(getServicesSuccess(response))
    } catch (error) {
        yield put(getServicesFail(error))
    }
}

function* onAddNewService({ payload }) {
    try {

        
        const response = yield call(addNewService, payload)

        console.log("RESPONSE:", response);
        yield put(addServiceSuccess(response.service))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addServiceFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateService({ payload: data }) {
    try {
        const response = yield call(updateService, data)
        yield put(updateServiceSuccess(response))
        toast.success("service  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateServiceFail(error))
        toast.error("service  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateService({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateService, payload)
        yield put(updateServiceSuccess(response.service))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateServiceFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteService({ payload: data }) {

    try {
        const response = yield call(deleteService, data)
        yield put(deleteServiceSuccess(response.serviceId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteServiceFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* serviceSaga() {
    yield takeEvery(GET_SERVICES, fetchServices)
    yield takeEvery(ADD_NEW_SERVICE, onAddNewService)
    yield takeEvery(UPDATE_SERVICE, onUpdateService)
    yield takeEvery(DELETE_SERVICE, onDeleteService)
}

export default serviceSaga;